module.exports = __webpack_public_path__ + "static/media/Amanda.e4df81da.png";